import * as i from 'types';

export const isYear = (period: i.Period) => {
  return period === 'year';
};
